import { createReducer } from 'deox';
import { getUserInfoActions } from '@/redux/actions/membership/users';

export interface UsersState {
  userInfo: {
    email: string;
    memberships: { organisationId: string; roleName: string }[];
    userId: string;
  };
}

const initialState: UsersState = {
  userInfo: {
    email: '',
    memberships: [],
    userId: '',
  },
};

const membershipUsers = createReducer(initialState, (handleAction) => [
  handleAction(getUserInfoActions.success, (state, { payload }) => ({
    ...state,
    userInfo: payload,
  })),
]);

export default membershipUsers;
